import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ModalNotificationComponent } from 'src/app/shared/components/modal-notification/modal-notification.component';
import { Booking } from 'src/app/shared/models/booking.model';
import { BookingService } from 'src/app/shared/services/booking.service';

@Component({
  selector: 'app-practitioner-bookings',
  templateUrl: './practitioner-bookings.component.html',
  styleUrls: ['./practitioner-bookings.component.scss']
})
export class PractitionerBookingsComponent implements OnInit {
  bookings: Booking[];
  @ViewChild('confirmation') confirmationModal: ModalNotificationComponent;

  constructor(private bookingService: BookingService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.loadBookings(params['id']);
    });
  }

  loadBookings(id: string) {
    this.bookingService.getBookings(id).subscribe(
      bookings => this.bookings = bookings.sort((a, b) => a.createdAt > b.createdAt ? 1 : 0),
      error => console.log(error)
    );
  }

  bookingCompleted(booking: Booking) {
    this.bookingService.updateBooking(booking)
      .then(_ => this.loadBookings(booking.practitionerId))
      .catch(_ => this.confirmationModal.open('Error', 'There was an error marking this booking as complete. Please try again later.', 'Okay'));
  }
}
